export default __webpack_public_path__ + "static/media/Home_shop_type-2.683e55a3.jpg";